<template>

    <div class="bodyComponente">
        <div class="cardsWrapper">
            <card-status texto-header="Banco de dados de localização " :texto-card="statusMessageDb" :is-erro= "dbCheck.statusCode !== 200"
			texto-card-class="textoCardClassProps"/>
            <card-status texto-header="Suntech Worker" :texto-card="statusMessageWorker" :texto-footer="statusMessageWorkerFooter"
             :is-erro="workerCheck.statusCode !== 200" texto-card-class="textoCardClassProps"/>
            <card-status texto-header="Suntech Server" :texto-card="statusMessageServer" :texto-footer="statusMessageServerFooter"
            :is-erro="serverCheck.statusCode !== 200" texto-card-class="textoCardClassProps"/>

        </div>
    </div>

</template>


<script>
	import CardStatus from "../components/CardStatus.vue";
	import { FetchDbDashboard, FetchServerDashboard, FetchWorkerDashboard} from "../services/location";

	export default {
		name: "LocationPage",
		components: {
			CardStatus
		},
		data () {
			return {
				dbCheck: {statusCode: 200},
				workerCheck: {statusCode: 200, message: "", pendingDocuments: ""},
				serverCheck: {statusCode: 200, message: "", lastLocation: ""},
				globalErro: false
			};
		},
		computed: {
			statusMessageDb () {
				if (this.dbCheck.statusCode === 200) return "Online";
				if (this.dbCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			},

			statusMessageWorker () {
				if (this.workerCheck.statusCode === 200) return `${this.workerCheck.message} `;
				if (this.workerCheck.statusCode === 418) return `${this.workerCheck.message} `;
				return "Api desconectada";
			},
			statusMessageWorkerFooter () {
				if (this.workerCheck.statusCode === 200) return `Localizações Pendentes: ${this.workerCheck.pendingDocuments}`;
				if (this.workerCheck.statusCode === 418) return `Localizações Pendentes: ${this.workerCheck.pendingDocuments}`;
				return "?";
			},


			statusMessageServer () {
				if (this.serverCheck.statusCode === 200) return `${this.serverCheck.message}`;
				if (this.serverCheck.statusCode === 418) return `${this.serverCheck.message}`;
				return "Api desconectada";
			},

			statusMessageServerFooter () {
				if (this.serverCheck.statusCode === 200) return `Ultimas Localizações: ${this.serverCheck.lastLocation}`;
				if (this.serverCheck.statusCode === 418) return `Ultimas Localizações: ${this.serverCheck.lastLocation}`;
				return "?";
			}
		},
		methods: {
			async dbDashboard () {
				const data = await FetchDbDashboard();
				this.dbCheck = data;
			},
			async workerDashboard () {
				const data = await FetchWorkerDashboard();
				this.workerCheck = data;
			},
			async serverDashboard () {
				const data = await FetchServerDashboard();
				this.serverCheck = data;
			}

		},
		mounted () {
			this.dbDashboard();
			this.workerDashboard();
			this.serverDashboard();


			this.refresh = setInterval(() => {
				this.dbDashboard();
				this.workerDashboard();
				this.serverDashboard();
			}, 30000);
		},
		beforeDestroy () {
			clearInterval(this.refresh);
		}
	};
</script>


<style scoped>
:deep(.textoCardClassProps){
    font-size: 11px;
}

.bodyComponente {
    width: calc(100% - 70px);
    margin-left: 70px;
    padding: 3rem 2rem;
    box-sizing: border-box;
}

.cardsWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
    max-width: 1100px;
    margin: 0 auto;
}

.cardsWrapper>* {
    flex: 0 0 280px;
    max-width: 280px;
}
</style>